import { internalMessageBus, sbMsgBus } from "../dependencies";
var DefaulLibConfig = {
    internalMsgBus: internalMessageBus,
    externalMsgBus: sbMsgBus,
    externalBroadcastEnabled: false,
    betslip: {
        addSelection: function () { },
        removeSelection: function () { },
        getSelections: function () { return ({}); },
        clearAll: function () { }
    }
};
export var setLibConfig = function (config) {
    LibConfig.externalMsgBus = config.externalMsgBus;
    LibConfig.internalMsgBus = config.internalMsgBus;
    LibConfig.externalBroadcastEnabled = config.externalBroadcastEnabled;
    LibConfig.betslip = config.betslip;
};
export var LibConfig = DefaulLibConfig;
//# sourceMappingURL=config.js.map